



































import Vue, { PropType } from "vue";

export interface AdminMessageSettingModalProps {
  adminMessage: string;
}

export default Vue.extend({
  name: "vc-modal-admin-message-setting",
  props: {
    adminMessage: {
      type: String as PropType<AdminMessageSettingModalProps["adminMessage"]>,
      default: "",
    },
  },
});
